import { Box, Text, styled, Stack } from '@ltvco/refresh-lib/theme';

export const HeaderContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
  gap: '16px',
  flexWrap: 'wrap',
});

export const ResultsInfoContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  minWidth: 0,
});

export const ResultsCountText = styled(Box)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  lineHeight: '24px',
  '& .count': {
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },
  '& .label': {
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
}));

export const SearchQueryText = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: '32px',
  color: theme.palette.text.primary,
  wordBreak: 'break-word',
}));

export const FiltersRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  gap: '4px',
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  lineHeight: '24px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const FiltersLabel = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const FilterItem = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 400,
}));

export const FilterSeparator = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  margin: '0 4px',
}));

export const ViewToggleContainer = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

// Skeleton components for loading state
export const SkeletonContainer = styled(Stack)({
  gap: '16px',
  flex: 1,
});
